/**
 * Espelha o que o PATCH /job/:id/reprocess aceita no backend (job em erro terminal
 * ou task em ERROR/FINAL_ERROR — aqui só temos o status do job na listagem).
 */
export function jobAllowsManualReprocess(job) {
  if (!job || job.status == null) return false;
  return ["ERROR", "FINAL_ERROR", "ERROR_FINALIZING"].includes(job.status);
}
